import React, { createContext, useEffect, useState } from "react";
import { getTranslation } from "../languageManager";
import { professionalService } from "../_services";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("mr");
 

  const t = (key) => getTranslation(language, key);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
